import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface GlobalAccessContextType {
  globalAviationAccess: boolean;
  refreshGlobalAccess: () => Promise<void>;
}

const GlobalAccessContext = createContext<GlobalAccessContextType | undefined>(undefined);

interface GlobalAccessProviderProps {
  children: ReactNode;
}

export function GlobalAccessProvider({ children }: GlobalAccessProviderProps) {
  const [globalAviationAccess, setGlobalAviationAccess] = useState(false);

  const fetchGlobalAccess = async () => {
    try {
      const response = await fetch('/api/settings/global-access', {
        credentials: 'include'
      });
      
      if (response.ok) {
        const data = await response.json();
        setGlobalAviationAccess(data.enabled);
      }
    } catch (error) {
      console.error('Failed to fetch global access settings:', error);
    }
  };

  const refreshGlobalAccess = async () => {
    await fetchGlobalAccess();
  };

  useEffect(() => {
    fetchGlobalAccess();
  }, []);

  return (
    <GlobalAccessContext.Provider value={{ globalAviationAccess, refreshGlobalAccess }}>
      {children}
    </GlobalAccessContext.Provider>
  );
}

export function useGlobalAccess() {
  const context = useContext(GlobalAccessContext);
  if (context === undefined) {
    throw new Error('useGlobalAccess must be used within a GlobalAccessProvider');
  }
  return context;
} 